import { sleep } from './sleep'

export async function waitForNavigation(to: string | (() => any)) {
  await Promise.all([
    Promise.resolve(
      typeof to === 'string' ? (window.location.href = to) : to(),
    ),
    sleep(10000),
  ])
}
